import { render } from "./WisLogo.vue?vue&type=template&id=9f76a392"
import script from "./WisLogo.vue?vue&type=script&lang=js"
export * from "./WisLogo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__